import { useNavigate } from 'react-router-dom';
import Background from '~/components/Background';
import Button from '~/components/Button';
import Cardbox from '~/components/Cardbox';
import Divider from '~/components/Divider';
import Gap from '~/components/Gap';
import StyledInput from '~/components/StyledInput';
import Text from '~/components/Text';
import { LOGIN_ROUTE } from '~/constants/routes';
import useForgotPassword from './useForgotPassword';

const ForgotPassword = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate(LOGIN_ROUTE);
  };

  const { isLoading, email, setEmail, handleSubmit } = useForgotPassword();

  return (
    <Background key="forgotpassword" data-component-name="ForgotPassword">
      <div className="full-view-dimensions center">
        <Cardbox>
          <Text align="center" size="lg">
            Forgot you password?
          </Text>
          <Gap t={24} />
          <Text>
            Enter your email address below and we'll send you a link to reset your password.
          </Text>
          <Gap t={32} />
          <Text size="xs">Email</Text>
          <Gap t={6} />
          <StyledInput
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="e.g. john@company.com"
          />
          <Gap t={24} />
          <Button disabled={isLoading || !email.trim()} size="full" onClick={handleSubmit}>
            Send Link
          </Button>

          <Divider margin="32px 0" />
          <div className="full-width spread align-center">
            <Text>Remember your password?</Text>

            <Button onClick={handleLoginRedirect} variant="secondary">
              Log in
            </Button>
          </div>
        </Cardbox>
      </div>
    </Background>
  );
};

export default ForgotPassword;
